import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _STATE_TO_ICON_MAP;
export var PLAY_STATE = 'play';
export var PAUSE_STATE = 'pause';
export var PLAY_ICON = 'play';
export var PAUSE_ICON = 'pause';
export var STATE_TO_ICON_MAP = (_STATE_TO_ICON_MAP = {}, _defineProperty(_STATE_TO_ICON_MAP, PLAY_STATE, PAUSE_ICON), _defineProperty(_STATE_TO_ICON_MAP, PAUSE_STATE, PLAY_ICON), _STATE_TO_ICON_MAP);